<mat-card>
  <mat-card-header>
    <mat-card-title>Gestión de Persona</mat-card-title>
    <mat-card-subtitle></mat-card-subtitle>
  </mat-card-header>

  <mat-card-content>

    <mat-label *ngIf="isValidating"><i class="fa fa-spinner fa-spin"></i> Cargando...</mat-label>
    <mat-label *ngIf="isSearching"><i class="fa fa-spinner fa-spin"></i> Buscando...</mat-label>
    <mat-label *ngIf="!isSearching && msgError?.length > 0">{{msgError}}</mat-label>

    <div *ngIf="!isSearching && persona != null">

      <form [formGroup]="personaFormGroup" *ngIf="canEdit">

        <!--DATOS DE PERSONA-->
        <mat-expansion-panel [expanded]="true">

          <mat-expansion-panel-header>
            <mat-panel-title>
              <mat-icon style="margin-top: -3px;">person</mat-icon> Datos de Persona
            </mat-panel-title>
            <mat-panel-description>
            </mat-panel-description>
          </mat-expansion-panel-header>

          <div fxLayout="row stretch" fxLayout.xs="column" class="zb-readonly">

            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-form-field appearance="outline" style="width: 100%">
                <mat-label>Nombre*</mat-label>
                <input matInput formControlName="Nombre" maxlength="150" (keyup.enter)="onGuardarPersona()">
                <mat-error
                  *ngIf="!personaFormGroup.controls['Nombre'].valid && personaFormGroup.controls['Nombre'].touched">
                  {{ getErrorNombre() }}
                </mat-error>
              </mat-form-field>
            </div>
            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-form-field appearance="outline" style="width: 100%">
                <mat-label>Apellido*</mat-label>
                <input matInput formControlName="Apellido" maxlength="150" (keyup.enter)="onGuardarPersona()">
                <mat-error
                  *ngIf="!personaFormGroup.controls['Apellido'].valid && personaFormGroup.controls['Apellido'].touched">
                  {{ getErrorApellido() }}
                </mat-error>
              </mat-form-field>
            </div>

            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-form-field appearance="outline" style="width: 100%">
                <mat-label *ngIf="!isTipoDocumentoSearching">Tipo Documento</mat-label>
                <mat-label *ngIf="isTipoDocumentoSearching">Cargando...</mat-label>
                <mat-select formControlName="TipoDocumentoId" (selectionChange)="onTipoDocumentoSelection()">
                  <mat-option>Ninguno</mat-option>
                  <mat-option *ngFor="let s of tipoDocumentoList" [value]="s.Id">{{s.Nombre}}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-form-field appearance="outline" style="width: 100%">
                <mat-label>Nro. Documento</mat-label>
                <input matInput formControlName="NroDocumento" type="text" (change)="onNroDocumentoChange()"
                  maxlength="100" (keyup.enter)="onGuardarPersona()">
                <mat-error
                  *ngIf="!personaFormGroup.controls['NroDocumento'].valid && personaFormGroup.controls['NroDocumento'].touched">
                  {{ getErrorNroDocumento() }}
                </mat-error>
              </mat-form-field>
            </div>

            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-form-field appearance="outline" style="width: 100%">
                <mat-label>CUIT/CUIL</mat-label>
                <input matInput formControlName="Cuit" type="number" (keyup.enter)="onGuardarPersona()">
              </mat-form-field>
            </div>
            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-form-field appearance="outline" style="width: 100%">
                <mat-label>Fecha Nacimiento</mat-label>
                <input matInput [matDatepicker]="fechaNacimientoPicker" formControlName="FechaNacimiento" readonly
                  (click)="fechaNacimientoPicker.open()">
                <mat-datepicker-toggle style="display:inline-block;" matSuffix [for]="fechaNacimientoPicker">
                </mat-datepicker-toggle>
                <mat-datepicker-toggle style="display:inline-block;" matSuffix (click)="clearDate('FechaNacimiento')">
                  <mat-icon matDatepickerToggleIcon>clear</mat-icon>
                </mat-datepicker-toggle>
                <mat-datepicker #fechaNacimientoPicker></mat-datepicker>
              </mat-form-field>
            </div>

            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-form-field appearance="outline" style="width: 100%">
                <mat-label>Mail de Contacto</mat-label>
                <input matInput formControlName="MailContacto" (keyup.enter)="onGuardarPersona()" maxlength="255">
                <mat-error
                  *ngIf="!personaFormGroup.controls['MailContacto'].valid && personaFormGroup.controls['MailContacto'].touched">
                  {{ getErrorMailContacto() }}
                </mat-error>
              </mat-form-field>
            </div>
            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-form-field appearance="outline" style="width: 100%">
                <mat-label>Móvil de Contacto</mat-label>
                <input matInput formControlName="MovilContacto" (keyup.enter)="onGuardarPersona()" maxlength="100">
                <mat-error
                  *ngIf="!personaFormGroup.controls['MovilContacto'].valid && personaFormGroup.controls['MovilContacto'].touched">
                  {{ getErrorMovilContacto() }}
                </mat-error>
              </mat-form-field>
            </div>

            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-form-field appearance="outline" style="width: 100%">
                <mat-label>Móvil de Contacto Otro</mat-label>
                <input matInput formControlName="MovilContactoOtro" (keyup.enter)="onGuardarPersona()" maxlength="100">
              </mat-form-field>
            </div>
            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-form-field appearance="outline" style="width: 100%">
                <mat-label *ngIf="!isEstadoCivilSearching">Estado Civil</mat-label>
                <mat-label *ngIf="isEstadoCivilSearching">Cargando...</mat-label>
                <mat-select formControlName="EstadoCivilId">
                  <mat-option *ngFor="let s of estadoCivilList" [value]="s.Id">{{s.Nombre}}</mat-option>
                </mat-select>
                <mat-error
                  *ngIf="!personaFormGroup.controls['EstadoCivilId'].valid && personaFormGroup.controls['EstadoCivilId'].touched">
                  {{ getErrorEstadoCivilId() }}
                </mat-error>
              </mat-form-field>
            </div>

            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-form-field appearance="outline" style="width: 100%">
                <mat-label *ngIf="!isPaisSearching">Nacionalidad</mat-label>
                <mat-label *ngIf="isPaisSearching">Cargando...</mat-label>
                <mat-select formControlName="PaisId">
                  <mat-option *ngFor="let s of paisList" [value]="s.Id">{{s.Nombre}}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div fxFlex=50 fxFlex.xs=100 class="flex-item" style="margin-top: 20px;">
              <mat-checkbox [(ngModel)]="persona.Activo" [ngModelOptions]="{standalone: true}"
                (keyup.enter)="onGuardarPersona()" color="primary">Activo</mat-checkbox>
            </div>

          </div>

        </mat-expansion-panel>

        <br/>
        
        <!--DATOS DE DOMICILIO-->
        <mat-expansion-panel [expanded]="true">

          <mat-expansion-panel-header>
            <mat-panel-title>
              <mat-icon style="margin-top: -3px;">home</mat-icon> Datos de Domicilio
            </mat-panel-title>
            <mat-panel-description>
            </mat-panel-description>
          </mat-expansion-panel-header>

          <div fxLayout="row stretch" fxLayout.xs="column" class="zb-readonly">

            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-form-field appearance="outline" style="width: 100%">
                <mat-label>Domicilio DNI</mat-label>
                <input matInput formControlName="DomicilioDni" (keyup.enter)="onGuardarPersona()">
                <mat-error
                  *ngIf="!personaFormGroup.controls['DomicilioDni'].valid && personaFormGroup.controls['DomicilioDni'].touched">
                  {{ getErrorDomicilioDni() }}
                </mat-error>
              </mat-form-field>
            </div>
            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-form-field appearance="outline" style="width: 100%">
                <mat-label>Código Postal DNI</mat-label>
                <input matInput formControlName="CodigoPostalDni" (keyup.enter)="onGuardarPersona()">
                <mat-error
                  *ngIf="!personaFormGroup.controls['CodigoPostalDni'].valid && personaFormGroup.controls['CodigoPostalDni'].touched">
                  {{ getErrorCodigoPostalDni() }}
                </mat-error>
              </mat-form-field>
            </div>

            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-form-field appearance="outline" style="width: 100%">
                <mat-label *ngIf="!isProvinciaSearching">Provincia</mat-label>
                <mat-label *ngIf="isProvinciaSearching">Cargando...</mat-label>
                <mat-select formControlName="ProvinciaId">
                  <mat-option>Seleccionar</mat-option>
                  <mat-option *ngFor="let s of provinciaList" [value]="s.Id">{{s.Nombre}}</mat-option>
                </mat-select>
                <mat-error
                  *ngIf="!personaFormGroup.controls['ProvinciaId'].valid && personaFormGroup.controls['ProvinciaId'].touched">
                  {{ getErrorProvincia() }}
                </mat-error>
              </mat-form-field>
            </div>
            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-form-field appearance="outline" style="width: 100%">
                <mat-label>Localidad/Barrio</mat-label>
                <input matInput formControlName="LocalidadBarrio" (keyup.enter)="onGuardarPersona()">
                <mat-error
                  *ngIf="!personaFormGroup.controls['LocalidadBarrio'].valid && personaFormGroup.controls['LocalidadBarrio'].touched">
                  {{ getErrorLocalidadBarrio() }}
                </mat-error>
              </mat-form-field>
            </div>

            <hr style="margin:20px 0px; width: 100%;">

            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-form-field appearance="outline" style="width: 100%">
                <mat-label>Domicilio Real</mat-label>
                <input matInput formControlName="DomicilioReal" (keyup.enter)="onGuardarPersona()">
                <mat-error
                  *ngIf="!personaFormGroup.controls['DomicilioReal'].valid && personaFormGroup.controls['DomicilioReal'].touched">
                  {{ getErrorDomicilioReal() }}
                </mat-error>
              </mat-form-field>
            </div>
            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-form-field appearance="outline" style="width: 100%">
                <mat-label>Código Postal Real</mat-label>
                <input matInput formControlName="CodigoPostalReal" (keyup.enter)="onGuardarPersona()">
                <mat-error
                  *ngIf="!personaFormGroup.controls['CodigoPostalReal'].valid && personaFormGroup.controls['CodigoPostalReal'].touched">
                  {{ getErrorCodigoPostalReal() }}
                </mat-error>
              </mat-form-field>
            </div>

            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-form-field appearance="outline" style="width: 100%">
                <mat-label *ngIf="!isProvinciaSearching">Provincia Real</mat-label>
                <mat-label *ngIf="isProvinciaSearching">Cargando...</mat-label>
                <mat-select formControlName="ProvinciaRealId">
                  <mat-option>Seleccionar</mat-option>
                  <mat-option *ngFor="let s of provinciaList" [value]="s.Id">{{s.Nombre}}</mat-option>
                </mat-select>
                <mat-error
                  *ngIf="!personaFormGroup.controls['ProvinciaRealId'].valid && personaFormGroup.controls['ProvinciaRealId'].touched">
                  {{ getErrorProvinciaReal() }}
                </mat-error>
              </mat-form-field>
            </div>
            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-form-field appearance="outline" style="width: 100%">
                <mat-label>Localidad/Barrio Real</mat-label>
                <input matInput formControlName="LocalidadBarrioReal" (keyup.enter)="onGuardarPersona()">
                <mat-error
                  *ngIf="!personaFormGroup.controls['LocalidadBarrioReal'].valid && personaFormGroup.controls['LocalidadBarrioReal'].touched">
                  {{ getErrorLocalidadReal() }}
                </mat-error>
              </mat-form-field>
            </div>

          </div>

        </mat-expansion-panel>

      </form>

      <ng-container *ngIf="!canEdit">

        <!--DATOS DE PERSONA-->
        <mat-expansion-panel [expanded]="true">

          <mat-expansion-panel-header>
            <mat-panel-title>
              <mat-icon style="margin-top: -3px;">person</mat-icon> Datos de Persona
            </mat-panel-title>
            <mat-panel-description>
            </mat-panel-description>
          </mat-expansion-panel-header>

          <div fxLayout="row stretch" fxLayout.xs="column" class="zb-readonly">

            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Domicilio DNI</b>: {{persona.DomicilioDni}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>
            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Código Postal DNI</b>: {{persona.CodigoPostalDni}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>

            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Provincia</b>: {{persona.ProvinciaNombre}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>
            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Localidad/Barrio</b>: {{persona.LocalidadBarrio}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>

          </div>

        </mat-expansion-panel>

        <br/>

        <!--DATOS DE DOMICILIO-->
        <mat-expansion-panel [expanded]="true">

          <mat-expansion-panel-header>
            <mat-panel-title>
              <mat-icon style="margin-top: -3px;">home</mat-icon> Datos de Domicilio
            </mat-panel-title>
            <mat-panel-description>
            </mat-panel-description>
          </mat-expansion-panel-header>

          <div fxLayout="row stretch" fxLayout.xs="column" class="zb-readonly">

            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Domicilio DNI</b>: {{persona.DomicilioDni}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>
            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Código Postal DNI</b>: {{persona.CodigoPostalDni}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>

            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Provincia</b>: {{persona.ProvinciaNombre}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>
            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Localidad/Barrio</b>: {{persona.LocalidadBarrio}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>

          </div>

          <hr style="margin:20px 0px; width: 100%;">

          <div fxLayout="row stretch" fxLayout.xs="column" class="zb-readonly">

            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Domicilio Real</b>: {{persona.DomicilioReal}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>
            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Código Postal Real</b>: {{persona.CodigoPostalReal}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>

            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Provincia Real</b>: {{persona.ProvinciaRealNombre}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>
            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label><b>Localidad/Barrio Real</b>: {{persona.LocalidadBarrioReal}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>

          </div>

        </mat-expansion-panel>

      </ng-container>

      <ng-container *ngIf="persona != null && persona.Id > 0">

        <br/>

        <!--DATOS DE BIOMETRICOS-->
        <mat-expansion-panel [expanded]="true">

          <mat-expansion-panel-header>
            <mat-panel-title>
              <mat-icon style="margin-top: -3px;">image_search</mat-icon> Datos Biométricos
            </mat-panel-title>
            <mat-panel-description>
            </mat-panel-description>
          </mat-expansion-panel-header>

          <div fxLayout="row stretch" fxLayout.xs="column" class="zb-readonly">

            <div fxFlex=100 fxFlex.xs=100 class="flex-item" fxLayoutAlign="center" style="margin-bottom: 15px;">
              <mat-label><u><b>Datos Biométricos</b></u></mat-label>
            </div>
  
            <div fxFlex=33 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column" style="margin-top: 12px;">
                  <div fxFlex=90 fxFlex.xs=100 class="flex-item">
                    <a href="{{persona?.FotoDniFrenteUrl}}" target="_blank" *ngIf="hasPersonaFotoDniFrente()">Ver Foto DNI Frente</a>
                    <mat-label class="text-label" *ngIf="!hasPersonaFotoDniFrente()">
                      <b><i class="fa fa-exclamation-triangle" style="margin-right: 5px;"></i> No tiene imagen de DNI frente</b>
                    </mat-label>
                  </div>
                  <div fxFlex=10 fxFlex.xs=100 class="flex-item" *ngIf="!isImageLoading">
                    <a style="cursor: pointer;" (click)="fileInputDniFrente.click()" title="Cargar nueva imagen"><i
                        class="fa fa-upload fa-1x"></i></a>
                    <input class="text-label" hidden type="file" (change)="convertFileToBase64($event, 'DniFrente')"
                      accept="image/*" #fileInputDniFrente>
                  </div>
                </div>
              </mat-expansion-panel>
            </div>
            <br />
            <div fxFlex=33 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column" style="margin-top: 12px;">
                  <div fxFlex=90 fxFlex.xs=100 class="flex-item">
                    <a href="{{persona?.FotoDniDorsoUrl}}" target="_blank" *ngIf="hasPersonaFotoDniDorso()">Ver Foto DNI Dorso</a>
                    <mat-label class="text-label" *ngIf="!hasPersonaFotoDniDorso()">
                      <b><i class="fa fa-exclamation-triangle" style="margin-right: 5px;"></i> No tiene imagen de DNI dorso</b>
                    </mat-label>
                  </div>
                  <div fxFlex=10 fxFlex.xs=100 class="flex-item" *ngIf="!isImageLoading">
                    <a style="cursor: pointer;" (click)="fileInputDniDorso.click()" title="Cargar nueva imagen"><i
                        class="fa fa-upload fa-1x"></i></a>
                    <input class="text-label" hidden type="file" (change)="convertFileToBase64($event, 'DniDorso')"
                      accept="image/*" #fileInputDniDorso>
                  </div>
                </div>
              </mat-expansion-panel>
            </div>
            <br />
            <div fxFlex=33 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column" style="margin-top: 12px;">
                  <div fxFlex=90 fxFlex.xs=100 class="flex-item">
                    <a href="{{persona?.FotoSelfieUrl}}" target="_blank" *ngIf="hasPersonaFotoSelfie()">Ver Foto Selfie</a>
                    <mat-label class="text-label" *ngIf="!hasPersonaFotoSelfie()">
                      <b><i class="fa fa-exclamation-triangle" style="margin-right: 5px;"></i> No tiene imagen de selfie</b>
                    </mat-label>
                  </div>
                  <div fxFlex=10 fxFlex.xs=100 class="flex-item" *ngIf="!isImageLoading">
                    <a style="cursor: pointer;" (click)="fileInputSelfie.click()" title="Cargar nueva imagen"><i
                        class="fa fa-upload fa-1x"></i></a>
                    <input class="text-label" hidden type="file" (change)="convertFileToBase64($event, 'Selfie')"
                      accept="image/*" #fileInputSelfie>
                  </div>
                </div>
              </mat-expansion-panel>
            </div>
  
          </div>

        </mat-expansion-panel>
        
        <ng-container *ngIf="canViewUsuarios">

          <hr style="margin:20px 0px; width: 100%;">

          <mat-expansion-panel [expanded]="false">

            <mat-expansion-panel-header>
              <mat-panel-title>
                <mat-icon style="margin-top: -3px;">supervisor_account</mat-icon> Usuarios Asociados
              </mat-panel-title>
              <mat-panel-description>
              </mat-panel-description>
            </mat-expansion-panel-header>

            <div fxLayout="row stretch" fxLayout.xs="column">

              <mat-label *ngIf="isUsuariosAsociadosSearching">Buscando...</mat-label>
              <mat-label *ngIf="!isUsuariosAsociadosSearching && usuariosAsociadosError.length > 0">
                {{usuariosAsociadosError}}</mat-label>

              <ejs-grid #grid [dataSource]='usuariosAsociadosList' [allowPaging]="true" [allowSorting]="true"
                *ngIf="!isUsuariosAsociadosSearching" [selectionSettings]='selectionOptions'
                [pageSettings]='pageSettings' [allowResizing]='true'>
                <e-columns>
                  <e-column field='Login' headerText='Usuario' width=90></e-column>
                  <e-column field='Estado' headerText='Estado' width=90></e-column>
                  <e-column field='Mail' headerText='Mail' width=90></e-column>
                  <e-column field='Activo' headerText='Activo' width=90>
                    <ng-template #template let-data>
                      {{data.Activo ? 'Sí' : 'No'}}
                    </ng-template>
                  </e-column>
                  <e-column field='Bloqueado' headerText='Bloqueado' width=90>
                    <ng-template #template let-data>
                      {{data.Bloqueado ? 'Sí' : 'No'}}
                    </ng-template>
                  </e-column>
                  <e-column headerText='Acciones' width=90 *ngIf="canViewUsuarios">
                    <ng-template #template let-data>
                      <a style="cursor: pointer; margin-right: 5px" (click)="editUser(data)"><i
                          class="fa fa-eye fa-1x"></i></a>
                    </ng-template>
                  </e-column>
                </e-columns>
              </ejs-grid>

            </div>

          </mat-expansion-panel>

        </ng-container>

        <ng-container *ngIf="tenantFeatureFlags?.HabilitarControlPedidos && canViewEmpleados">

          <hr style="margin:20px 0px; width: 100%;">

          <mat-expansion-panel [expanded]="false">

            <mat-expansion-panel-header>
              <mat-panel-title>
                <mat-icon style="margin-top: -3px;">assignment_ind</mat-icon> Empleados Asociados
              </mat-panel-title>
              <mat-panel-description>
              </mat-panel-description>
            </mat-expansion-panel-header>

            <div fxLayout="row stretch" fxLayout.xs="column">

              <mat-label *ngIf="isEmpleadosAsociadosSearching">Buscando...</mat-label>
              <mat-label *ngIf="!isEmpleadosAsociadosSearching && empleadosAsociadosError.length > 0">
                {{empleadosAsociadosError}}
              </mat-label>

              <ejs-grid #grid [dataSource]='empleadosAsociadosList' [allowPaging]="true" [allowSorting]="true"
                *ngIf="!isEmpleadosAsociadosSearching" [selectionSettings]='selectionOptions'
                [pageSettings]='pageSettings' [allowResizing]='true'>
                <e-columns>
                  <e-column field='Legajo' headerText='Legajo' width=90></e-column>
                  <e-column field='FechaIngreso' headerText='Ingreso' width=90>
                    <ng-template #template let-data>
                      {{data.FechaIngreso | date:'dd/MM/yyyy'}}
                    </ng-template>
                  </e-column>
                  <e-column field='FechaEgreso' headerText='Egreso' width=90>
                    <ng-template #template let-data>
                      {{data.FechaEgreso | date:'dd/MM/yyyy'}}
                    </ng-template>
                  </e-column>
                  <e-column headerText='Acciones' width=90 *ngIf="canViewEmpleados">
                    <ng-template #template let-data>
                      <a style="cursor: pointer; margin-right: 5px" (click)="editEmpleado(data)"><i class="fa fa-eye fa-1x"></i></a>
                    </ng-template>
                  </e-column>
                </e-columns>
              </ejs-grid>

            </div>

          </mat-expansion-panel>

        </ng-container>

        <ng-container *ngIf="tenantFeatureFlags?.HabilitarGestionUf && canViewUfs">

          <hr style="margin:20px 0px; width: 100%;">

          <mat-expansion-panel [expanded]="false">

            <mat-expansion-panel-header>
              <mat-panel-title>
                <mat-icon style="margin-top: -3px;">home</mat-icon> {{'UnidadFuncional' | translate}} Asociada
              </mat-panel-title>
              <mat-panel-description>
              </mat-panel-description>
            </mat-expansion-panel-header>

            <div fxLayout="row stretch" fxLayout.xs="column">

              <mat-label *ngIf="isUfsAsociadasSearching">Buscando...</mat-label>
              <mat-label *ngIf="!isUfsAsociadasSearching && ufAsociadosError.length > 0">{{ufAsociadosError}}
              </mat-label>

              <ejs-grid #grid [dataSource]='ufsAsociadasList' [allowPaging]="true" [allowSorting]="true"
                *ngIf="!isUfsAsociadasSearching" [selectionSettings]='selectionOptions' [pageSettings]='pageSettings'
                [allowResizing]='true'>
                <e-columns>
                  <e-column field='Codigo' headerText='Código' width=90></e-column>
                  <e-column field='Numero' headerText='Número' width=90></e-column>
                  <e-column field='TipoUnidadNombre' headerText='Tipo Unidad' width=90></e-column>
                  <e-column field='Comunidad' headerText='Comunidad' width=90>
                    <ng-template #headerTemplate let-data>
                      {{'Comunidad' | translate}}
                    </ng-template>
                  </e-column>
                  <e-column field='Consorcio' headerText='Consorcio' width=90></e-column>
                  <e-column field='CantidadAmbientes' headerText='Ambientes' width=90></e-column>
                  <e-column headerText='Acciones' width=90 *ngIf="canViewUfs">
                    <ng-template #template let-data>
                      <a style="cursor: pointer; margin-right: 5px" (click)="editUf(data)"><i
                          class="fa fa-eye fa-1x"></i></a>
                    </ng-template>
                  </e-column>
                </e-columns>
              </ejs-grid>

            </div>

          </mat-expansion-panel>

        </ng-container>

        <ng-container *ngIf="canViewIncidencias">

          <hr style="margin:20px 0px; width: 100%;">

          <mat-expansion-panel [expanded]="false">

            <mat-expansion-panel-header>
              <mat-panel-title>
                <mat-icon style="margin-right: 5px;">error</mat-icon> Incidencias Asociadas
              </mat-panel-title>
              <mat-panel-description>
              </mat-panel-description>
            </mat-expansion-panel-header>

            <div fxLayout="row stretch" fxLayout.xs="column" style="margin-top: 10px;">

              <div fxFlex=100 fxFlex.xs=100 class="flex-item">

                <mat-label *ngIf="isIncidenciasSearching">Buscando...</mat-label>
                <ejs-grid #gridIncidencias [dataSource]='incidenciasList' [allowPaging]="true" [allowSorting]="true"
                  *ngIf="!isIncidenciasSearching" [selectionSettings]='selectionOptions' [pageSettings]='pageSettings'
                  [allowResizing]='true'>
                  <e-columns>
                    <e-column field='Id' headerText='#' width=60></e-column>
                    <e-column field='FechaUltimoMensaje' headerText='Fecha Ult. Actualización' type="Date"
                      format="dd/MM/yyyy HH:mm" width=60></e-column>
                    <e-column field='IncidenciaUsuarioCategoriaNombre' headerText='Categoría' width=90></e-column>
                    <e-column field='ProveedorNombre' headerText='Proveedor' width=90></e-column>
                    <e-column field='EstadoNombre' headerText='Estado' width=90></e-column>
                    <e-column field='Asunto' headerText='Asunto' width=120></e-column>
                    <e-column headerText='Acciones' width=40 *ngIf="canViewIncidencias">
                      <ng-template #template let-data>
                        <a style="cursor: pointer; margin-right: 18px" (click)="editIncidencia(data)">
                          <mat-icon style="width: 5px; font-size: 18px;" title="Ver incidencia">visibility</mat-icon>
                        </a>
                      </ng-template>
                    </e-column>
                  </e-columns>
                </ejs-grid>

              </div>

            </div>

          </mat-expansion-panel>

        </ng-container>

        <ng-container *ngIf="canViewProveedores">

          <hr style="margin:20px 0px; width: 100%;">

          <mat-expansion-panel [expanded]="false">

            <mat-expansion-panel-header>
              <mat-panel-title>
                <mat-icon style="margin-top: -3px;">work</mat-icon> Proveedores Asociados
              </mat-panel-title>
              <mat-panel-description>
              </mat-panel-description>
            </mat-expansion-panel-header>

            <div fxLayout="row stretch" fxLayout.xs="column">

              <mat-label *ngIf="isProveedoresAsociadosSearching">Buscando...</mat-label>
              <mat-label *ngIf="!isProveedoresAsociadosSearching && proveedoresAsociadosError.length > 0">
                {{proveedoresAsociadosError}}</mat-label>

              <ejs-grid #grid [dataSource]='proveedoresAsociadosList' [allowPaging]="true" [allowSorting]="true"
                *ngIf="!isProveedoresAsociadosSearching" [selectionSettings]='selectionOptions'
                [pageSettings]='pageSettings' [allowResizing]='true'>
                <e-columns>
                  <e-column field='Codigo' headerText='Código' width=90></e-column>
                  <e-column field='RazonSocial' headerText='Razón Social' width=90></e-column>
                  <e-column field='Cuit' headerText='CUIT' width=90></e-column>
                  <e-column field='PaisNombre' headerText='País' width=90></e-column>
                  <e-column field='LocalidadBarrio' headerText='Localidad' width=90></e-column>
                  <e-column headerText='Acciones' width=90 *ngIf="canViewProveedores">
                    <ng-template #template let-data>
                      <a style="cursor: pointer; margin-right: 5px" (click)="editProveedor(data)"><i
                          class="fa fa-eye fa-1x"></i></a>
                    </ng-template>
                  </e-column>
                </e-columns>
              </ejs-grid>

            </div>

          </mat-expansion-panel>

        </ng-container>

      </ng-container>

    </div>

  </mat-card-content>

  <mat-card-actions style="margin-bottom: 20px;">
    <div fxLayout="row stretch" fxLayout.xs="column">
      <button mat-raised-button (click)="onGuardarPersona()" *ngIf="canAdd || canEdit" [disabled]="isProcessing()"
        color="primary" class="zb-button">{{isPersonSaving ? 'Guardando...' : 'Guardar'}}</button>
      <button mat-raised-button (click)="onCancel()" color="warn"
        class="zb-button">{{canAdd || canEdit ? 'Cancelar' : 'Cerrar'}}</button>
      <button mat-raised-button (click)="onDelete()" *ngIf="canDelete && persona != null && persona.Id > 0"
        [disabled]="isPersonSaving" color="warn" class="zb-button">
        {{isDeleting ? 'Eliminando...' : 'Eliminar' }}
      </button>
    </div>
  </mat-card-actions>

</mat-card>